import React, { useEffect } from 'react';
import { CollapseBlock, Spinner } from '../../../../common/index.jsx';
import {
  useGetUserQuery,
  useGetUsersQuery,
  useSaveUserMutation,
} from '../../../../../redux/services/users.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import { AppBarCMS } from '../../../../basic/index.jsx';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { formattedFullName } from '../../../../../utils/helpers/CommonHelper.jsx';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';
import PersonForm from '../../Dashboard/PersonProfile/PersonForm.jsx';

const UserProfileEdit = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const { data: userDetail, isLoading } = useGetUserQuery(id);
  const [saveUser, { isSuccess }] = useSaveUserMutation();
  const { refetch } = useGetUsersQuery();

  const [form] = Form.useForm();

  useEffect(() => {
    if (isSuccess) {
      showSaveSuccess();
      navigate(routes.cmsUsers);
      refetch();
    }
  }, [isSuccess]);

  if (isLoading) {
    return <Spinner />;
  }

  const { teacher } = userDetail;
  const isStudent = teacher == null;
  const title = `${t('Správa profilu používateľa')}`;
  const { mail, newsletters, ldap_mail } = userDetail;

  let initials = {
    name: formattedFullName(userDetail),
    mail,
    newsletters,
    ldap_mail,
  };

  if (isStudent) {
    initials = {
      ...initials,
      school_group: userDetail.activeStudent.school_group,
    };
  } else {
    const { phone, room, description_sk, description_en, homepage } = teacher;
    initials = {
      ...initials,
      phone,
      room,
      description_sk,
      description_en,
      homepage,
    };
  }

  return (
    <>
      <AppBarCMS
        title={title}
        backUrl={routes.cmsUsers}
        backUrlTooltip={t('Používatelia')}
        permissionsBasic={'users'}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock title={t('Profil')}>
          <PersonForm
            isStudent={isStudent}
            initials={initials}
            onSubmit={(values) => {
              const body = {
                mail: values.mail,
                newsletters: values.newsletters,
                ldap_mail: values.ldap_mail,
                phone: values.phone,
                room: values.room,
                description_sk: values.description_sk,
                description_en: values.description_en,
                homepage: values.homepage,
              };

              saveUser({ body, id });
            }}
            form={form}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default UserProfileEdit;
